/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Shadow_Size_AriaInputs */

const en_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadow Size`)
};

const fr_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de l'ombre`)
};

const de_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schattengröße`)
};

const it_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione dell'ombra`)
};

const ru_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер тени`)
};

const es_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de la sombra`)
};

const zh_cn2_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阴影大小`)
};

const ja_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影のサイズ`)
};

const hi_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छाया का आकार`)
};

const pt_pt2_video_export_shadow_size_aria = /** @type {(inputs: Video_Export_Shadow_Size_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da sombra`)
};

/**
* | output |
* | --- |
* | "Shadow Size" |
*
* @param {Video_Export_Shadow_Size_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_shadow_size_aria = /** @type {((inputs?: Video_Export_Shadow_Size_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Shadow_Size_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_shadow_size_aria(inputs)
	if (locale === "de") return de_video_export_shadow_size_aria(inputs)
	if (locale === "it") return it_video_export_shadow_size_aria(inputs)
	if (locale === "ru") return ru_video_export_shadow_size_aria(inputs)
	if (locale === "es") return es_video_export_shadow_size_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_shadow_size_aria(inputs)
	if (locale === "ja") return ja_video_export_shadow_size_aria(inputs)
	if (locale === "hi") return hi_video_export_shadow_size_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_shadow_size_aria(inputs)
	return en_video_export_shadow_size_aria(inputs)
});